/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Negotiation_AnalyzingInputs */

const en_negotiation_analyzing = /** @type {(inputs: Negotiation_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const de_negotiation_analyzing = /** @type {(inputs: Negotiation_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const fr_negotiation_analyzing = /** @type {(inputs: Negotiation_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const es_negotiation_analyzing = /** @type {(inputs: Negotiation_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const it_negotiation_analyzing = /** @type {(inputs: Negotiation_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const nl_negotiation_analyzing = /** @type {(inputs: Negotiation_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const pl_negotiation_analyzing = /** @type {(inputs: Negotiation_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const fi_negotiation_analyzing = /** @type {(inputs: Negotiation_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const da_negotiation_analyzing = /** @type {(inputs: Negotiation_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const sv_negotiation_analyzing = /** @type {(inputs: Negotiation_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

/**
* | output |
* | --- |
* | "Analyzing..." |
*
* @param {Negotiation_AnalyzingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const negotiation_analyzing = /** @type {((inputs?: Negotiation_AnalyzingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Negotiation_AnalyzingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_negotiation_analyzing(inputs)
	if (locale === "fr") return fr_negotiation_analyzing(inputs)
	if (locale === "es") return es_negotiation_analyzing(inputs)
	if (locale === "it") return it_negotiation_analyzing(inputs)
	if (locale === "nl") return nl_negotiation_analyzing(inputs)
	if (locale === "pl") return pl_negotiation_analyzing(inputs)
	if (locale === "fi") return fi_negotiation_analyzing(inputs)
	if (locale === "da") return da_negotiation_analyzing(inputs)
	if (locale === "sv") return sv_negotiation_analyzing(inputs)
	return en_negotiation_analyzing(inputs)
});